// extracted by mini-css-extract-plugin
module.exports = {"hidden":"style_hidden__2qRyU","visible":"style_visible__2XbzW","container":"style_container__2lat6","chat":"style_chat__34AdW"};